import { Col, Collapse, Container, Row } from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import { ContentWrapCss } from '../../../components/Numerology/Common.css'
import { Paragraph, TextDela } from '../../../components/NumerologyV2/index.css'
import Title from '../../../components/NumerologyV2/Title'
import AppContext from '../../../context/AppContext'
import NumerologyApi from '../../../services/numerology'
import { IRulingNumber } from '../../../services/numerology/@type'
import { EDevice } from '../../MainLayout'
import { Box } from '../../NumerologyContainerV2/Numerology.css'
import { CustomHeader } from '../../NumerologyResultContainer/NumerologyResult.css'
import { DetailCss } from '../RulingNumberDetail.css'
interface IProps {
	numberMeaning: IRulingNumber | null
}
export default function Detail({ numberMeaning }: IProps) {
	const { breakpoint, t } = useContext(AppContext)
	const router = useRouter()
	const { rulingNumberId } = router.query

	return (
		<Container>
			<DetailCss>
				<Col>
					<Box className='center'>
						<Title
							title={`Số chủ đạo: <span>${rulingNumberId}</span>`}
							marker='triangle'
							backgound='oval'
							colorMarker='#A2F6BE'
						/>
						<Paragraph
							style={{ marginBottom: 0 }}
							dangerouslySetInnerHTML={{
								__html: numberMeaning?.description ?? ''
							}}
						/>
					</Box>
				</Col>

				<Row gutter={10}>
					{!numberMeaning?.items
						? null
						: numberMeaning?.items?.map((item, index) => {
								return (
									<Col key={index}>
										<Collapse
											collapse={
												index === 0 ? false : true
											}
											header={
												<CustomHeader>
													<TextDela>
														{item.title}
													</TextDela>
												</CustomHeader>
											}
										>
											<ContentWrapCss
												style={{
													padding:
														breakpoint !==
														EDevice.MOBILE
															? '20px 48px'
															: '10px 12px'
												}}
												dangerouslySetInnerHTML={{
													__html: item.content ?? ''
												}}
											/>
										</Collapse>
									</Col>
								)
						  })}
				</Row>
			</DetailCss>
		</Container>
	)
}
